import React from 'react';
import { Switch, Route, Redirect, BrowserRouter, useRouteMatch } from 'react-router-dom';

import LeadsIndex from 'pages/Leads';
import AccountSetup from 'pages/AccountSetUp/LandingPage';
import PaymentDetail from 'pages/Invoice/PaymentDetail';
import PaymentForm from 'pages/Invoice/PaymentForm';
import PaymentRefund from 'pages/Invoice/PaymentRefund';
import StepForms from 'pages/AccountSetUp/SetupForms';
import ProjectsIndex from 'pages/Projects';
import NotesIndex from 'pages/Notes';
import NoteEditor from 'pages/Notes/NoteEditor';
import Account from 'pages/Account';
import NoteTemplatesIndex from 'pages/BusinessSettings/Templates/Notes';
import Event from 'pages/Event';
import Scheduler from 'pages/Scheduler';
import PublicScheduler from 'pages/Scheduler/PublicScheduler';
import SchedulerReschedule from 'pages/Scheduler/SchedulerReschedule';
import SchedulerCancel from 'pages/Scheduler/SchedulerCancel';
import NotFound from 'pages/NotFound';
// import CalendarIndex from 'pages/Calendar';
import LeadsEmailer from 'pages/LeadsEmailer';
import BusinessSettings from 'pages/BusinessSettings';
import PausedLanding from './PausedLanding';
import CanceledLanding from './CanceledLanding';


export const PrivateRoutes = ({
  isPaused,
  hasUnpausedProjects,
  isOrgOwner,
  isChurned,
  isAccountCanceled,
  // isAdmin = false,
  isIntegrationsEnabled,
  hasSettingsPermission,
  hasActiveWeddings,
}) => {
  // Never display paused landing if in account pages.
  const isInAccount = useRouteMatch('/app/v2/account');
  // Display paused landing only if org is paused and user isn't invited to other projects.
  if (!isInAccount && isPaused && !hasUnpausedProjects) {
    return (
      <PausedLanding isOrgOwner={isOrgOwner}/>
    );
  }
  if (!hasActiveWeddings && !isInAccount && isAccountCanceled) {
    return (
      <CanceledLanding isChurned={isChurned} />
    );
  }

  return (
    <Switch>
      <Route path="/app/v2/:organization/leads"
        component={LeadsIndex}
        exact
      />
      <Route
        path="/app/v2/:organization/leads/status/:status"
        component={LeadsIndex}
        exact
      />
      <Route
        path="/app/v2/account-setup/get-started"
        component={AccountSetup}
        exact
      />
      <Route
        path="/app/v2/account-setup/step/:stepId"
        component={StepForms}
        exact
      />
      <Route
        path="/app/v2/invoice/:orgId/invoice/refund/:invoiceId/:transactionId"
        component={PaymentRefund}
        exact
      />
      <Route
        path="/app/v2/projects"
        component={ProjectsIndex}
        exact
      />
      <Route path="/app/v2/project/:projectId/tools/notes/:noteId"
        component={NoteEditor}
        exact
      />
      <Route path="/app/v2/projects/:projectId/tools/notes"
        component={NotesIndex}
      />
      <Route path="/app/v2/account/:activeTab?"
        component={Account}
      />
      <Route path="/app/v2/pro/:orgId/settings/templates/notes-templates"
        component={NoteTemplatesIndex}
        exact
      />
      <Route path="/app/v2/pro/:orgId/settings/templates/notes-templates/:templateId"
        component={NoteEditor}
        exact
      />
      {hasSettingsPermission && (
        <Route path="/app/v2/pro/:orgId/settings/:activeTab?"
          component={BusinessSettings}
          exact
        />
      )}
      {hasSettingsPermission && isIntegrationsEnabled && (
        <Route path="/app/v2/pro/:orgId/settings/:activeTab/scheduler-editor"
          component={BusinessSettings}
          exact
        />
      )}
      {/* #TODO: Remove comments for next release
      <Route path="/app/v2/calendar"
        component={CalendarIndex}
      />
      */}
      {isIntegrationsEnabled && (
        <Route path="/app/v2/scheduler"
          component={Scheduler}
          exact
        />
      )}
      <Route path="/app/v2/leads-emailer/:orgId/:leadId/"
        component={LeadsEmailer}
      />
      <Route component={() => <Redirect to="/app/v2/projects" />} />
    </Switch>
  );
};

export const PublicRoutes = () => (
  <BrowserRouter>
    <Switch>
      <Route
        path="/app/v2/invoice/pay/:invoiceId"
        component={PaymentDetail}
        exact
      />
      <Route
        path="/app/v2/invoice/pay/:invoiceId/process"
        component={PaymentForm}
        exact
      />
      <Route
        path="/app/v2/scheduler/view/:configId"
        component={PublicScheduler}
        exact
      />
      <Route
        path="/app/v2/scheduler/reschedule/:bookingRef"
        component={SchedulerReschedule}
        exact
      />
      <Route
        path="/app/v2/scheduler/cancel/:bookingRef"
        component={SchedulerCancel}
        exact
      />
      <Route
        path="/app/v2/:type/:urlSlug/:activeTab"
        component={Event}
        exact
      />
      <Route
        component={NotFound}
      />
    </Switch>
  </BrowserRouter>
);

export const WebComponentRoutes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/app/v2/projects/:projectId/tools/notes"
        component={NotesIndex}
      />
      <Route path="/app/v2/projects/:projectId/tools/notes/:noteId"
        component={NoteEditor}
      />
      <Route path="/app/v2/pro/:orgId/settings/templates/notes-templates"
        component={NoteTemplatesIndex}
        exact
      />
      <Route path="/app/v2/pro/:orgId/settings/templates/notes-templates/:templateId"
        component={NoteEditor}
        exact
      />
    </Switch>
  </BrowserRouter>
);
